import { render, staticRenderFns } from "./Scorm2004.vue?vue&type=template&id=671ae27d&scoped=true"
import script from "./Scorm2004.vue?vue&type=script&lang=js"
export * from "./Scorm2004.vue?vue&type=script&lang=js"
import style0 from "./Scorm2004.vue?vue&type=style&index=0&id=671ae27d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ae27d",
  null
  
)

export default component.exports